import { useDispatch } from 'react-redux';
import { ChatIcon } from '@rsos/assets/icons';
import { Button, Text } from '@rsos/base-components';
import {
  openResourcePanel,
  setResourcePanelView,
  setSelectedRequest,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import { HalfWidthContent } from '../tabs/OverviewTab/OverviewTab.styles';

/**
 * Generic resource request card for the overview tab.
 * Allows users to request various services like air ambulance and tow trucks.
 * Opens the ResourceRequestPanel when clicked.
 */
const ResourceRequestCard = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    // Clear any previously selected request
    dispatch(setSelectedRequest(null));
    // Set the resource panel to the list view
    dispatch(setResourcePanelView('list'));
    dispatch(openResourcePanel());
  };

  return (
    <HalfWidthContent
      backgroundColor="background"
      data-name="resource-request-card"
    >
      <div
        style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}
      >
        <ChatIcon color="primaryText" height={12} width={12} />
        <Text
          color="primaryText"
          data-name="resource-request-card-title"
          fontWeight="bold"
          lineHeight="1"
          marginLeft="4px"
          size="normal"
        >
          Request Resources
        </Text>
      </div>
      <Text
        color="primaryText"
        data-name="resource-request-card-description"
        marginBottom="16px"
        size="normal"
      >
        Request services for various emergencies or situations like air
        ambulance and tow trucks.
      </Text>
      <Button
        btnType="tertiary"
        dataName="resource-request-card-button"
        grow
        noMargin
        onClick={handleClick}
      >
        <Text color="secondaryText" lineHeight="1" size="normal">
          Request
        </Text>
      </Button>
    </HalfWidthContent>
  );
};

export default ResourceRequestCard;
